import {PolicyMailLogList} from "./PolicyMailLogList";
import {PolicyMailLogEdit} from "./PolicyMailLogEdit";
import {PolicyMailLogCreate} from "./PolicyMailLogCreate";

export default {
    list: PolicyMailLogList,
    edit: PolicyMailLogEdit
};
